import { observer } from 'mobx-react-lite'
import { useReviewViewContext } from 'pages/reviews/context'
import styles from './styles.module.scss'

export const PreviewLogo = observer(() => {
  const { imageUrl } = useReviewViewContext()

  if (!imageUrl) return null

  return (
    <div
      className={styles.logo}
      style={{
        backgroundImage: imageUrl
          ? `url(${imageUrl})`
          : 'var(--background-primary-inverted-primary)',
      }}
    />
  )
})
